var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.2514 109.375H43.7514M96.2514 109.375C105.916 109.375 113.751 117.21 113.751 126.875H26.2514C26.2514 117.21 34.0864 109.375 43.7514 109.375M96.2514 109.375V89.6875C96.2514 86.0631 93.3132 83.125 89.6889 83.125H84.6044M43.7514 109.375V89.6875C43.7514 86.0631 46.6895 83.125 50.3139 83.125H55.3984M84.6044 83.125H55.3984M84.6044 83.125C81.4116 77.6057 79.39 71.3241 78.8792 64.6201M55.3984 83.125C58.5912 77.6057 60.6128 71.3241 61.1235 64.6201M30.6264 24.7121C24.8963 25.5453 19.2243 26.5577 13.6162 27.7434C16.243 43.3037 29.1385 55.3748 45.091 56.7452M30.6264 24.7121V26.25C30.6264 38.5454 36.262 49.5245 45.091 56.7452M30.6264 24.7121V15.8719C43.4914 14.0613 56.637 13.125 70.0014 13.125C83.3657 13.125 96.5114 14.0613 109.376 15.8719V24.7121M45.091 56.7452C49.6852 60.5025 55.1441 63.2422 61.1235 64.6201M109.376 24.7121V26.25C109.376 38.5454 103.741 49.5245 94.9118 56.7452M109.376 24.7121C115.106 25.5453 120.779 26.5577 126.387 27.7434C123.76 43.3037 110.864 55.3748 94.9118 56.7452M94.9118 56.7452C90.3176 60.5025 84.8587 63.2422 78.8792 64.6201M78.8792 64.6201C76.026 65.2776 73.0543 65.625 70.0014 65.625C66.9485 65.625 63.9767 65.2776 61.1235 64.6201",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.daf8cefffd9a418f1670a8bd60d2082a.svg";
export { ForwardRef as ReactComponent };